module.exports = __webpack_public_path__ + "images/ui-bg_flat_10_000000_40x100.png";